import { Typography, Grid } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface MemberJoinDateProps {
    customerData: CustomerInterface
}

const MemberJoinDate: React.FC<MemberJoinDateProps> = ({
    customerData
}) => {
    return (
        <>
            {customerData.join_date &&
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{color: "#333399"}}>入会日</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">{format(new Date(customerData.join_date), "yyyy年MM月dd日")}</Typography>
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default MemberJoinDate